import { partialBind, } from 'remeda';
import { appointmentBookRequestValidate, } from './appointment/AppointmentApi.binding.js';
import { appointmentBook, searchBookableAppointments, } from './appointment/AppointmentApi.js';
import { clientInvoiceDownloadInvoice, clientInvoiceDownloadRequestTan, } from './client/invoice/ClientInvoiceApi.js';
import { commonConfig, version, } from './common/CommonApi.js';
import { searchTherapist, } from './user/UserApi.js';
export { appointmentBookRequestValidate, appointmentBookResponseValidate, appointmentSaveRequestValidate, appointmentSaveResponseValidate, searchBookableAppointmentsRequestValidate, searchBookableAppointmentsResponseValidate, } from './appointment/AppointmentApi.binding.js';
export { appointmentSeriesInterval, appointmentState, isMedicalFeeScheduleLine, } from './appointment/AppointmentApi.js';
export { appointmentTypeLocation, } from './appointment/AppointmentTypeApi.js';
export { clientInvoiceDownloadInvoiceRequestValidate, clientInvoiceDownloadInvoiceResponseValidate, clientInvoiceDownloadTanRequestValidate, clientInvoiceDownloadTanResponseValidate, } from './client/invoice/ClientInvoiceApi.binding.js';
export { configRequestValidate, configResponseValidate, versionRequestValidate, versionResponseValidate, } from './common/CommonApi.binding.js';
export { countries, } from './countries.js';
export { invoiceSearchResponseValidate, } from './invoice/InvoiceApi.binding.js';
export { translation, } from './translation/translation.js';
export { postClientRequestValidate, } from './user/UserApi.binding.js';
export { coverageTypeMap, coverageTypes, genderToSalutation, genderType, getKeyForCoverageType, getKeyForTherapeuticFocus, getKeyForTreatmentMethod, invoiceDigitalType, locationType, publicVisibilityType, Roles, salutation, searchTherapistRequestValidate, searchTherapistResponseValidate, searchTherapistSortType, THERAPEUTIC_FOCUS, TREATMENT_METHODS, userClientOpenApiFields, userCommonOpenApiFields, userInsuranceType, userJobTitleType, userSpecialistOpenApiFields, } from './user/UserApi.js';
export { nonEmptyEmail, nonEmptyString, nonNullableBoolean, nullableBoolean, nullableEnum, nullableNonEmptyEmail, nullableNonEmptyString, nullableNumber, pagedSchemaOld, } from './validator.js';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function Api({ baseUrl }) {
    return {
        common: {
            version: {
                request: partialBind(version, baseUrl),
            },
            config: {
                request: partialBind(commonConfig, baseUrl),
            },
        },
        client: {
            therapist: {
                search: {
                    request: partialBind(searchTherapist, baseUrl),
                },
            },
            appointment: {
                book: {
                    validateRequest: appointmentBookRequestValidate,
                    request: partialBind(appointmentBook, baseUrl),
                },
                bookable: {
                    request: partialBind(searchBookableAppointments, baseUrl),
                },
            },
            invoice: {
                requestTan: {
                    request: partialBind(clientInvoiceDownloadRequestTan, baseUrl),
                },
                download: {
                    request: partialBind(clientInvoiceDownloadInvoice, baseUrl),
                },
            },
        },
    };
}
//# sourceMappingURL=index.js.map